import DoneIcon from "@mui/icons-material/Done";
import {
  Box,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  styled,
  Switch,
  Tooltip,
  Typography
} from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_SUBSCRIPTION_MANAGEMENT } from "../../actions/EndPoints";
import CardFive from "../../assets/CardFive.svg";
import CardFour from "../../assets/CardFour.svg";
import CardOne from "../../assets/CardOne.svg";
import CardThree from "../../assets/CardThree.svg";
import CardTwo from "../../assets/CardTwo.svg";
import CustomTextfeild from "../../components/CustomInputs/CustomTextfield";
import SubscriptionDropdown from "../../components/CustomInputs/SubscriptionDropdown";
import SubscriptionTextfield from "../../components/CustomInputs/SubscriptionTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import {
  getDiscounts,
  getFeatures,
  getSubscriptionById,
  getVisitLimit,
  updateProduct
} from "../../slices/Subscription/SubscriptionSlice";
import CommonUtil from "../../Util/CommonUtils";
import ViewSubscription from "./ViewSubscription";

const Android12Switch = styled(Switch)(({ mode, theme }) => ({
  padding: 8,
  bottom: 5,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    border: "1px solid #888B8D",
    backgroundColor: "white",
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#888B8D",
    boxShadow: "none",
    width: 14,
    height: 14,
    margin: 2,
    marginTop: 3,
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#fff", // Change thumb color when checked
    "&:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "60%",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.97" viewBox="0 0 8 5.97"><path fill="%23226BAB" d="M17.772,14.911l-3.381,3.381-1.353-1.352a.956.956,0,0,0-1.352,1.352l2.03,2.029a.955.955,0,0,0,1.352,0l4.057-4.057a.956.956,0,1,0-1.352-1.352Z" transform="translate(-11.405 -14.63)"/></svg>')`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
    },
  },
  "& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#226BAB !important",
    opacity: 1,
  },
}));

function EditSubscription(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const subscriptionId = props.history.location.state;
  const [openView, setOpenView] = useState(false);
  const { t } = useTranslation();
  const [features, setFeatures] = useState([]);
  const [allFeatures, setAllFeatures] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState([]);
  const [featureNameList, setFeatureNameList] = useState([]);
  const [periodValue, setPeriodValue] = useState("");
  const [currency, setCurrency] = useState("$");
  const [feature1, setFeature1] = useState("");
  const [feature2, setFeature2] = useState("");
  const [feature3, setFeature3] = useState("");
  const [feature4, setFeature4] = useState("");
  const [priceState, setPriceState] = useState(false);
  const [feature5, setFeature5] = useState("");
  const [type, setType] = useState(0);
  const [period, setperiod] = useState(0);
  const [toggle, setToggle] = useState({});
  const [priceStrategyId, setPriceStrategyId] = useState("");
  const [featuresForEdit, setFeaturesForEdit] = useState([]);
  const [discountId, setDiscountId] = useState("");
  const [featureNamesForEdit, setFeatureNamesForEdit] = useState([]);
  const [visitorCount, setVisitorCount] = useState(0);
  const [productId, setProductId] = useState("");
  const [state, setState] = React.useState({
    name: "",
    feature: featuresForEdit,
    country: "US",
    currency: "USD",
    validity: true,
    subscriptionType: "",
    monthly_price: 0,
    annual_price: 0,
    visitLimit: visitorCount,
    discount: discountId,
  });

  const [error, setError] = useState({
    name: false,
    price: false,
    annual_price: false,
    monthly_price: false,
    country: false,
    currency: false,
    periodValue: false,
    visitorCount: false,
  });

  useEffect(() => {
    loadProduct(subscriptionId);
  }, []);

  useEffect(() => {
    loadFeatures();
  }, []);

  useEffect(() => {
    const query = {
      pageNumber: 1,
      pageSize: 100,
    };

    dispatch(getDiscounts(query))
      .unwrap()
      .then((data) => {
        if (data.code === "200" && data.data) {
          const discountList = data.data.results;
          if (discountList.length > 0) {
            setDiscountId(discountList[0].id);
          }
        }
      });
  }, []);

  const loadFeatures = () => {
    const query = {
      pageNumber: 1,
      pageSize: 100,
    };

    dispatch(getFeatures(query))
      .unwrap()
      .then((data) => {
        if (data.code === "200" && data.data) {
          setAllFeatures(data.data.results);
        } else {
          setAllFeatures([]);
        }
      });
  };

  const handleChangeDropdown = (event) => {
    if (event.target.value === "Yearly") {
      setPeriodValue("Yearly");
      setType(2);
      setperiod(1);
    } else {
      setPeriodValue("Monthly");
      setType(1);
      setperiod(1);
    }
    setError({
      ...error,
      periodValue: false,
    });
  };

  const cancel = (e) => {
    history.push(REACT_SUBSCRIPTION_MANAGEMENT);
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(state.name)) {
      Toast(t("Please Enter Plan Name"), "error");
      setError({ ...error, name: true });
      return;
    }

    if (CommonUtil.isEmptyString(state.subscriptionType)) {
      Toast(t("Please select Subscription Type"), "error");
      setError({ ...error, periodValue: true });
      return;
    }

    if (CommonUtil.isEmptyArray(featuresForEdit)) {
      Toast(t("Please select atleast one Subscription Information"), "error");
      return;
    }

    dispatch(
      updateProduct({
        ...state,
        feature: featuresForEdit,
        discount: discountId,
        visitLimit: visitorCount,
        productId,
      })
    )
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4039" && data.data) {
          Toast(data.message, "success");
          history.push("/vis/subscription-management");
        } else {
          Toast(data.message, "error");
          return;
        }
      });

    const visitorCountPayload = {
      subscriptionId: subscriptionId,
      visitorCount: visitorCount,
    };
  };

  const handleChange = (event) => {
    setState({
      ...state,
      name: event.target.value,
    });
    setError({
      name: false,
    });
  };

  const handleCurrencyChange = (event) => {
    if (event.target.value === "USD") {
      setCurrency("$");
      setState({
        ...state,
        currency: "USD",
      });
    } else if (event.target.value === "Euro") {
      setCurrency("€");
      setState({
        ...state,
        currency: "EUR",
      });
    }
  };

  const handleChange2 = (event) => {
    if (periodValue === "Yearly") {
      setState({
        ...state,
        annual_price: event.target.value,
      });
    } else {
      setState({
        ...state,
        monthly_price: event.target.value,
      });
    }
  };

  const handleVisitorCount = (event) => {
    setVisitorCount(event.target.value);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 17) {
      return text.substring(0, 26) + "...";
    } else {
      return text;
    }
  };

  const handleTextPrice = (text) => {
    if (text && text.length > 9) {
      return text.substring(0, 9) + "...";
    } else {
      return text;
    }
  };

  const handleToggleChange = (event, featureId, featureName) => {
    const defaultToggleState = { ...toggle };

    if (event.target.checked === true && !featuresForEdit.includes(featureId)) {
      featuresForEdit.push(featureId);
      featureNamesForEdit.push(featureName);
    } else {
      const featureIdIndex = featuresForEdit.indexOf(featureId);
      if (featureIdIndex !== -1) {
        featuresForEdit.splice(featureIdIndex, 1);
      }

      const indexToRemove = featureNamesForEdit.indexOf(featureName);
      if (indexToRemove !== -1) {
        featureNamesForEdit.splice(indexToRemove, 1);
      }
    }

    defaultToggleState[featureName] = event.target.checked;

    setSelectedFeature([...selectedFeature]);
    setFeatureNameList([...featureNameList]);
    setToggle(defaultToggleState);
    setSelectedFeature(selectedFeature);
    setFeatureNameList(featureNameList);

    if (featureNamesForEdit[0] !== undefined) {
      setFeature1(featureNamesForEdit[0]);
    } else {
      setFeature1("");
    }
    if (featureNamesForEdit[1] !== undefined) {
      setFeature2(featureNamesForEdit[1]);
    } else {
      setFeature2("");
    }
    if (featureNamesForEdit[2] !== undefined) {
      setFeature3(featureNamesForEdit[2]);
    } else {
      setFeature3("");
    }
    if (featureNamesForEdit[3] !== undefined) {
      setFeature4(featureNamesForEdit[3]);
    } else {
      setFeature4("");
    }
    if (featureNamesForEdit[4] !== undefined) {
      setFeature5(featureNamesForEdit[4]);
    } else {
      setFeature5("");
    }
  };

  const loadProduct = (subscriptionId) => {
    dispatch(getSubscriptionById(subscriptionId))
      .unwrap()
      .then((data) => {
        if (data.code === "200" && data.data) {
          setFeatures(data.data.feature);
          const defaultToggleState = {};
          const featureIds = [];
          const featureNamesEdit = [];
          data.data.feature.forEach((feature) => {
            defaultToggleState[feature.name] = true;
            featureIds.push(feature.id);
            featureNamesEdit.push(feature.name);
          });

          setFeatureNamesForEdit(featureNamesEdit);
          setFeaturesForEdit(featureIds);
          setToggle(defaultToggleState);
          if (data.data.type_name === "Pay monthly") {
            setState({
              ...state,
              subscriptionType: "Monthly",
              name: data.data.price_strategy_name,
              monthly_price: data.data.original_price,
              id: data.data.price_strategy,
            });
            setCurrency("$");
            setPeriodValue("Monthly");
          } else {
            setState({
              ...state,
              subscriptionType: "Yearly",
              name: data.data.price_strategy_name,
              annual_price: data.data.original_price,
              id: data.data.price_strategy,
            });
            setPeriodValue("Yearly");
          }
          dispatch(getVisitLimit(subscriptionId))
            .unwrap()
            .then((data) => {
              setVisitorCount(data.data.visitLimit);
              setProductId(data.data.id);
            });
        } else {
          setFeatures([]);
        }
      });
  };

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  return (
    <>
      <HeaderToolbar title={t("SUBSCRIPTION_EDIT_HEADER")} back_button={true} />
      <Box
        style={{
          padding: "0px",
          width: "100%",
          height: `${height}px`,
          overflowY: "auto",
          scrollbarWidth: "none",
          borderRadius: "10px",
          marginTop: '10px'
        }}>
        <div
          style={{
            flexGrow: 1,
            overflowY: "auto",
            height: "100%",
            overflowX: "hidden",
          }}
        >
          <Paper>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={2}
              style={{
                width: "85%",
                padding: "20px",
              }}
            >
              <Grid item sm={12} md={6}>
                <CustomTextfeild
                  label={t("SUBSCRIPTIONPLANNAME")}
                  name={"name"}
                  error={error.name}
                  value={state.name}
                  handleChange={handleChange}
                  type={"text"}
                  validation="restrictLength"
                  disabled={state.name === "Free Trial" ? true : false}
                  required
                  autoComplete="off"
                />
              </Grid>
              <Grid item sm={12} md={6}>
                <SubscriptionDropdown
                  label={
                    <>
                      {t("SELECTSUBSCRIPTIONTYPEMANDATORY")} <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  value={state.name === "Free Trial" ? "Free Trial" : state.subscriptionType}
                  disabled={true}
                  error={error.periodValue}
                  name="Subscription Type"
                  handleChange={(e) => handleChangeDropdown(e)}
                />
              </Grid>
              <Grid item sm={12} md={6}>
                <SubscriptionTextfield
                  name={"price"}
                  value={periodValue === "Yearly" ? state.annual_price : state.monthly_price}
                  error={error.price}
                  handleChange={handleChange2}
                  handleCurrencyChange={handleCurrencyChange}
                  type={"text"}
                  periodValue={state.subscriptionType}
                  validation="numeric"
                  label={t('CUSTDATABLE08')}
                  required={true}
                  inputProps={{ maxLength: 6 }}
                  disabled
                />
              </Grid>
              <Grid item sm={12} md={6}>
                <CustomTextfeild
                  label={t("SUBSCRIPTIONVISITIONCREATION")}
                  name={"visitLimit"}
                  value={visitorCount}
                  error={error.visitLimit}
                  handleChange={handleChange}
                  type={"number"}
                  validation="numeric"
                  required={true}
                  disabled
                />
              </Grid>
            </Grid>
          </Paper>
          <Box>
            <Grid container spacing={2} sx={{ margin: "10px 0" }}>
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                sx={{
                  backgroundColor: "#ffffff",
                  padding: 2,
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "#0F5A9C",
                    fontFamily: "normal normal medium 18px/22px Roboto",
                  }}
                >
                  {t("SUBSCRIPTIONINFROMATION")}
                </Typography>
                <div style={{ maxHeight: 400, marginTop: 16 }}>
                  <FormControl component="fieldset" fullWidth >
                    {allFeatures.map((feature) => (
                      <FormGroup key={feature.id} sx={{ marginBottom: 1 }}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item xs={8}>
                            
                            <FormLabel
                              component="legend"
                              sx={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                fontFamily: "normal normal normal 16px/19px Roboto",
                                fontSize: "14px",
                                color: "#242424 !important",
                                opacity: 1
                              }}
                            >
                              {feature.name}
                            </FormLabel>
                          </Grid>
                          <Grid item xs={4} sx={{ textAlign: "right" }}>
                            <Android12Switch
                              checked={toggle[feature.name]}
                              disabled={true}
                              onChange={(event) =>
                                handleToggleChange(event, feature.id, feature.name)
                              }
                              name={feature.name}
                            />
                          </Grid>
                        </Grid>
                      </FormGroup>
                    ))}
                  </FormControl>
                </div>
              </Grid>
              <Grid
                item
                xs={4}
                md={3}
                lg={5.9}
                sx={{
                  backgroundColor: "#ffffff",
                  padding: 2,
                  borderRadius: 2,
                  marginLeft: 1,
                }}
              >
                <Box sx={{
                  position: "relative"
                }}>
                  <Card
                    sx={{
                      height: "480px",
                      width: "100%",
                      maxWidth: 360,
                      margin: "auto",
                      borderRadius: "20px"
                    }}
                  >
                    {(() => {
                      if (state.annual_price || state.monthly_price <= 100) {
                        return (
                          <CardMedia
                            component="img"
                            src={CardOne}
                            alt="Plan Image"
                            sx={{
                              marginTop: "-21px",
                              marginLeft: "-23px",
                              width: "410px",
                            }}
                          />
                        );
                      } else if (state.monthly_price <= 200) {
                        return (
                          <CardMedia
                            component="img"
                            src={CardTwo}
                            alt="Plan Image"
                            sx={{
                              marginTop: "-21px",
                              marginLeft: "-23px",
                              width: "410px",
                            }}
                          />
                        );
                      } else if (state.monthly_price <= 300) {
                        return (
                          <CardMedia
                            component="img"
                            src={CardThree}
                            alt="Plan Image"
                            sx={{
                              marginTop: "-21px",
                              marginLeft: "-23px",
                              width: "410px",
                            }}
                          />
                        );
                      } else if (state.monthly_price <= 400) {
                        return (
                          <CardMedia
                            component="img"
                            src={CardFour}
                            alt="Plan Image"
                            sx={{
                              marginTop: "-21px",
                              marginLeft: "-23px",
                              width: "410px",
                            }}
                          />
                        );
                      } else {
                        return (
                          <CardMedia
                            component="img"
                            src={CardFive}
                            alt="Plan Image"
                            sx={{
                              marginTop: "-21px",
                              marginLeft: "-23px",
                              width: "410px",
                            }}
                          />
                        );
                      }
                    })()}
                    <div
                      style={{
                        position: "absolute",
                        color: "white",
                        top: 115,
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "19px",
                        font: "normal normal normal 19px/17px Roboto",
                      }}
                    >
                      {state.subscriptionType}
                    </div>
                    <Tooltip title={`${state.name}`} placement="bottom-start">
                      <div
                        style={{
                          position: "absolute",
                          color: "white",
                          top: 21,
                          left: "50%",
                          transform: "translateX(-50%)",
                          fontSize: "33px",
                          font: "normal normal normal 30px/32px Roboto",
                        }}
                      >
                        {handleTextPrice(state.name)}
                      </div>
                    </Tooltip>
                    <div
                      style={{
                        position: "absolute",
                        color: "white",
                        top: 59,
                        left: "50%",
                        transform: "translateX(-50%)",
                        fontSize: "40px",
                        fontWeight: "bold",
                        font: "normal normal bold 40px/48px Roboto",
                      }}
                    >
                      {periodValue === "Yearly"
                        ? `$${state.annual_price}`
                        : `$${state.monthly_price}`}
                    </div>

                    {[featureNamesForEdit[0], featureNamesForEdit[1], featureNamesForEdit[2], featureNamesForEdit[3], featureNamesForEdit[4]]
                      .filter(Boolean)
                      .map((feature, index) => (
                        <Grid
                          container
                          spacing={2}
                          key={index}
                          style={{
                            marginLeft: "30px",
                            position: "absolute",
                            color: "black",
                            top: 220 + index * 40,
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Grid item>
                            <DoneIcon
                              sx={{
                                fontSize: "23px",
                                color: "green",
                                marginRight: "5px",
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <Tooltip title={`${feature}`} placement="bottom-start">
                              <div
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {handleTextOverflow(feature)}
                              </div>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      ))}
                    <CardContent />
                    <CardActions>
                      <ViewSubscription
                        featureNameList={featureNamesForEdit}
                        planName={state.name}
                        price={
                          periodValue === "Yearly" ? state.annual_price : state.monthly_price
                        }
                        visitorCount={visitorCount}
                        subscriptionType={state.subscriptionType}
                        open={openView}
                      />
                    </CardActions>
                  </Card>
                </Box>
                <Box>

                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    sx={{ marginTop: 1, marginRight: 2.5 }}
                  >
                    <Grid item>
                      <CancelButtons
                        color="secondary"
                        onClick={cancel}
                        variant="contained"
                      >
                        <Typography>{t("COMMON008")}</Typography>
                      </CancelButtons>
                    </Grid>
                    <Grid item>
                      <SubmitButtons onClick={handleSubmit} variant="contained">
                        <Typography>{t("COMMON007")}</Typography>
                      </SubmitButtons>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Box>
    </>
  );
}
export default EditSubscription;
